import {
  Colors,
  MOON_350,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SelectEntityContainer = styled.div`
  max-width: 300px;
  border: 1px solid ${TEAL_600};
  border-radius: 4px;
`;
SelectEntityContainer.displayName = 'S.SelectEntityContainer';

export const AccessControlsPageHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;
AccessControlsPageHeader.displayName = 'S.AccessControlsPageHeader';

export const RegistryLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;
RegistryLinkContainer.displayName = 'S.RegistryLinkContainer';

export const RegistryAdminsCopyHeader = styled.div`
  font-size: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
RegistryAdminsCopyHeader.displayName = 'S.RegistryAdminsCopyHeader';

export const RegistryAdminsCopyText = styled.div`
  margin-bottom: 10px;
`;
RegistryAdminsCopyText.displayName = 'S.RegistryAdminsCopyText';

export const RegistryAdminsContainer = styled.div`
  border: 1px solid ${MOON_350};
  background: ${Colors.WHITE};
  padding: 20px;
`;
RegistryAdminsContainer.displayName = 'S.RegistryAdminsContainer';

export const ProtectedAliasesContainer = styled.div`
  border: 1px solid ${MOON_350};
  background: ${Colors.WHITE};
  padding: 20px;
  margin-top: 50px;
`;
ProtectedAliasesContainer.displayName = 'S.ProtectedAliasesContainer';
